<template>
  <div class="app-container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>规格模板</span>
      </div>

      <!-- 操作按钮 -->
      <el-row :gutter="10" class="mb8">
        <el-col :span="1.5">
          <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button icon="el-icon-refresh" @click="getList">刷新</el-button>
        </el-col>
      </el-row>

      <!-- 搜索表单 -->
      <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px" style="margin-bottom: 20px;">
        <el-form-item label="模板名称" prop="templateName">
          <el-input
            v-model="queryParams.templateName"
            placeholder="请输入模板名称"
            clearable
            size="small"
            @keyup.enter.native="getList"
          />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="queryParams.status" placeholder="请选择" clearable size="small">
            <el-option label="启用" :value="1" />
            <el-option label="禁用" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="small" @click="getList">搜索</el-button>
          <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 数据表格 -->
      <el-table v-loading="loading" :data="specList">
        <el-table-column label="序号" align="center" width="80">
          <template slot-scope="scope">
            {{ (queryParams.current - 1) * queryParams.size + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="模板名称" align="center" prop="templateName" />
        <el-table-column label="规格项" align="center" prop="specItems" show-overflow-tooltip />
        <el-table-column label="状态" align="center" prop="status" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">
              {{ scope.row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" prop="createTime" width="180" />
        <el-table-column label="操作" align="center" width="280">
          <template slot-scope="scope">
            <el-button size="mini" type="text" icon="el-icon-setting" @click="handleConfigValues(scope.row)">配置规格值</el-button>
            <el-button size="mini" type="text" icon="el-icon-edit" @click="handleUpdate(scope.row)">修改</el-button>
            <el-button size="mini" type="text" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.current"
        :limit.sync="queryParams.size"
        @pagination="getList"
      />
    </el-card>

    <!-- 添加或修改规格模板对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="模板名称" prop="templateName">
          <el-input v-model="form.templateName" placeholder="请输入模板名称，如：颜色、尺寸" />
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" controls-position="right" style="width: 100%;" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 配置规格值对话框 -->
    <el-dialog title="配置规格值" :visible.sync="valueDialogVisible" width="700px" append-to-body>
      <div v-if="currentTemplate" style="margin-bottom: 15px;">
        <el-tag type="success" size="medium">当前模板：{{ currentTemplate.templateName }}</el-tag>
      </div>

      <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAddValue" style="margin-bottom: 15px;">新增规格值</el-button>

      <el-table :data="specValueList" border style="width: 100%">
        <el-table-column label="序号" align="center" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="规格值名称" align="center" prop="valueName" />
<!--        <el-table-column label="图片" align="center" prop="valueImage" width="100">-->
<!--          <template slot-scope="scope">-->
<!--            <el-image-->
<!--              v-if="scope.row.valueImage"-->
<!--              style="width: 40px; height: 40px"-->
<!--              :src="scope.row.valueImage"-->
<!--              fit="cover"-->
<!--            />-->
<!--            <span v-else>-</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column label="排序" align="center" prop="sort" width="80" />
        <el-table-column label="状态" align="center" prop="status" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="small">
              {{ scope.row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button size="mini" type="text" icon="el-icon-edit" @click="handleEditValue(scope.row)">修改</el-button>
            <el-button size="mini" type="text" icon="el-icon-delete" @click="handleDeleteValue(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button @click="valueDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 添加或修改规格值对话框 -->
    <el-dialog :title="valueDialogTitle" :visible.sync="valueFormVisible" width="500px" append-to-body>
      <el-form ref="valueForm" :model="valueForm" :rules="valueRules" label-width="100px">
        <el-form-item label="规格值名称" prop="valueName">
          <el-input v-model="valueForm.valueName" placeholder="请输入规格值名称，如：红色、大杯" />
        </el-form-item>
<!--        <el-form-item label="规格值图片" prop="valueImage">-->
<!--          <el-input v-model="valueForm.valueImage" placeholder="请输入图片URL（可选）" />-->
<!--        </el-form-item>-->
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="valueForm.sort" :min="0" controls-position="right" style="width: 100%;" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="valueForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="valueForm.remark" type="textarea" placeholder="请输入备注" :rows="2" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitValueForm">确 定</el-button>
        <el-button @click="valueFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSpecTemplatePage, insertSpecTemplate, updateSpecTemplate, deleteSpecTemplate } from '@/api/ordering/spec'
import { getSpecValueList, insertSpecValue, updateSpecValue, deleteSpecValue } from '@/api/ordering/spec'

export default {
  name: 'SpecTemplate',
  data() {
    return {
      loading: true,
      total: 0,
      specList: [],
      queryParams: {
        current: 1,
        size: 10,
        templateName: undefined,
        status: undefined
      },
      // 对话框相关
      dialogVisible: false,
      dialogTitle: '',
      form: {
        id: null,
        templateName: '',
        sort: 0,
        status: 1,
        remark: ''
      },
      rules: {
        templateName: [
          { required: true, message: '请输入模板名称', trigger: 'blur' }
        ]
      },
      // 规格值对话框相关
      valueDialogVisible: false,
      valueFormVisible: false,
      valueDialogTitle: '',
      currentTemplate: null,
      specValueList: [],
      valueForm: {
        id: null,
        templateId: null,
        valueName: '',
        valueImage: '',
        sort: 0,
        status: 1,
        remark: ''
      },
      valueRules: {
        valueName: [
          { required: true, message: '请输入规格值名称', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    /** 查询规格模板列表 */
    async getList() {
      this.loading = true
      try {
        const params = {
          current: this.queryParams.current,
          size: this.queryParams.size
        }

        // 添加搜索条件
        if (this.queryParams.templateName) {
          params.templateName = this.queryParams.templateName
        }
        if (this.queryParams.status !== undefined && this.queryParams.status !== null) {
          params.status = this.queryParams.status
        }

        const res = await getSpecTemplatePage(params)
        this.specList = res.records || []
        this.total = res.total || 0
      } catch (error) {
        console.error('获取规格模板列表失败', error)
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.resetForm()
      this.dialogTitle = '新增规格模板'
      this.dialogVisible = true
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.resetForm()
      this.form = {
        id: row.id,
        templateName: row.templateName,
        sort: row.sort || 0,
        status: row.status,
        remark: row.remark || ''
      }
      this.dialogTitle = '修改规格模板'
      this.dialogVisible = true
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      this.$confirm('是否确认删除规格模板"' + row.templateName + '"?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await deleteSpecTemplate(row.id)
          this.$message.success('删除成功')
          this.getList()
        } catch (error) {
          console.error('删除失败', error)
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },
    /** 提交表单 */
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            if (this.form.id) {
              await updateSpecTemplate(this.form)
              this.$message.success('修改成功')
            } else {
              await insertSpecTemplate(this.form)
              this.$message.success('新增成功')
            }
            this.dialogVisible = false
            this.getList()
          } catch (error) {
            console.error('保存失败', error)
            this.$message.error('保存失败')
          }
        }
      })
    },
    /** 取消按钮 */
    cancel() {
      this.dialogVisible = false
      this.resetForm()
    },
    /** 表单重置 */
    resetForm() {
      this.form = {
        id: null,
        templateName: '',
        sort: 0,
        status: 1,
        remark: ''
      }
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.current = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      if (this.$refs.queryForm) {
        this.$refs.queryForm.resetFields()
      }
      this.handleQuery()
    },
    /** 配置规格值 */
    handleConfigValues(row) {
      this.currentTemplate = row
      this.valueDialogVisible = true
      this.loadSpecValues()
    },
    /** 加载规格值列表 */
    async loadSpecValues() {
      try {
        const res = await getSpecValueList(this.currentTemplate.id)
        this.specValueList = res || []
      } catch (error) {
        console.error('获取规格值列表失败', error)
        this.$message.error('获取数据失败')
      }
    },
    /** 新增规格值 */
    handleAddValue() {
      this.valueDialogTitle = '新增规格值'
      this.valueForm = {
        id: null,
        templateId: this.currentTemplate.id,
        valueName: '',
        valueImage: '',
        sort: 0,
        status: 1,
        remark: ''
      }
      this.valueFormVisible = true
    },
    /** 修改规格值 */
    handleEditValue(row) {
      this.valueDialogTitle = '修改规格值'
      this.valueForm = {
        id: row.id,
        templateId: row.templateId,
        valueName: row.valueName,
        valueImage: row.valueImage || '',
        sort: row.sort || 0,
        status: row.status,
        remark: row.remark || ''
      }
      this.valueFormVisible = true
    },
    /** 删除规格值 */
    handleDeleteValue(row) {
      this.$confirm('是否确认删除规格值"' + row.valueName + '"?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await deleteSpecValue(row.id)
          this.$message.success('删除成功')
          this.loadSpecValues()
        } catch (error) {
          console.error('删除失败', error)
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },
    /** 提交规格值表单 */
    submitValueForm() {
      this.$refs.valueForm.validate(async valid => {
        if (valid) {
          try {
            if (this.valueForm.id) {
              await updateSpecValue(this.valueForm)
              this.$message.success('修改成功')
            } else {
              await insertSpecValue(this.valueForm)
              this.$message.success('新增成功')
            }
            this.valueFormVisible = false
            this.loadSpecValues()
          } catch (error) {
            console.error('保存失败', error)
            this.$message.error('保存失败')
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}

/* 弹窗内容间距优化 */
::v-deep .el-dialog__body {
  padding: 20px 30px;
}

/* 弹窗头部间距 */
::v-deep .el-dialog__header {
  padding: 20px 30px 15px;
  margin-right: 0;
}

/* 弹窗底部间距 */
::v-deep .el-dialog__footer {
  padding: 15px 30px 20px;
}

/* 表单项间距 */
::v-deep .el-form-item {
  margin-bottom: 20px;
}

/* 表格内操作按钮间距 */
.el-button + .el-button {
  margin-left: 8px;
}
</style>
